import { cn } from '../utils/cn'

export interface ErrorBannerProps {
  /** The error message to display */
  error: string
  /** Optional HTTP status code */
  code?: number
  /** Additional CSS classes */
  className?: string
}

/**
 * A simple error banner component for displaying error messages.
 * Centered layout with large heading and subtitle.
 * 
 * @example
 * <ErrorBanner error="Page not found" code={404} />
 */
export const ErrorBanner = ({ 
  error, 
  code, 
  className 
}: ErrorBannerProps) => {
  return (
    <div className={cn("flex flex-col gap-2 mt-12", className)}>
      <h2 className="text-center text-2xl font-bold mb-8">
        {code ? `${code} Error` : 'Error'}
      </h2>
      <p className="text-center text-lg text-gray-500">{error}</p>
    </div>
  )
}

export default ErrorBanner

